import { Equipe } from "../equipe";
import { Equipment } from "../equipment";
import { Operator } from "../operator";
export interface Shift {
  shiftId?: number;
  date: Date;
  time: ShiftEnum;
  tirId: number;
  siteId: number;
  equipementsIds: string;
  equipements?: Equipment[];
  equipeId?: number;
  operatorId?: number;
  isDeleted: boolean;

  operator?: Operator;
  equipe?: Equipe
}

export enum ShiftEnum {
  NightToMorning = 0,
  MorningToAfternoon = 1,
  AfternoonToEvening = 2,
}

const SHIFT_HOURS = {
  NightToMorning: { start: 22, end: 6 },
  MorningToAfternoon: { start: 6, end: 14 },
  AfternoonToEvening: { start: 14, end: 22 }
};

export class ShiftUtils {

  static formatShiftLabel(shift: ShiftEnum): string {
    const shiftDisplayMap = {
      [ShiftEnum.NightToMorning]: 'DONNEE_SUIVI_OP.MidnightToMorning',
      [ShiftEnum.MorningToAfternoon]: 'DONNEE_SUIVI_OP.MorningToAfternoon',
      [ShiftEnum.AfternoonToEvening]: 'DONNEE_SUIVI_OP.AfternoonToMidnight',
    };
    return shiftDisplayMap[shift];
  }

  static calculateShiftTimeRange(date: Date, shift: ShiftEnum): { startDate: Date, endDate: Date } {
    const baseDate = new Date(date);
    // Convertir en heure locale pour éviter les problèmes de fuseau horaire
    const localDate = new Date(baseDate.getTime() - baseDate.getTimezoneOffset() * 60000);
    localDate.setHours(0, 0, 0, 0);

    const shiftTimes = {
      [ShiftEnum.NightToMorning]: { start: SHIFT_HOURS.NightToMorning.start, end: SHIFT_HOURS.NightToMorning.end },
      [ShiftEnum.MorningToAfternoon]: { start: SHIFT_HOURS.MorningToAfternoon.start, end: SHIFT_HOURS.MorningToAfternoon.end },
      [ShiftEnum.AfternoonToEvening]: { start: SHIFT_HOURS.AfternoonToEvening.start, end: SHIFT_HOURS.AfternoonToEvening.end },
    };

    const { start, end } = shiftTimes[shift];
    const startDate = new Date(localDate);

    // Utiliser l'heure locale pour tous les shifts
    startDate.setHours(start, 0, 0, 0);

    const endDate = new Date(localDate);
    // Utiliser end - 1 minute pour exclure l'heure exacte de fin (ex: 13h59:59 au lieu de 14h00:00)
    // Cela garantit que les positions de 14h00 appartiennent au shift suivant
    endDate.setHours(end - 1, 59, 59, 999);

    // Si l'heure de fin est inférieure à l'heure de début (shift nuit 22h-6h),
    // le shift commence la veille : 22h de J-1 à 6h de la date sélectionnée
    if (end < start) {
      startDate.setDate(localDate.getDate() - 1);
    }

    return { startDate, endDate };
  }
}

